// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import HeaderClickable, { HeaderClickableStyles } from "@synd/App/Components/Header/HeaderClickable";
import { xIsAuthenticated } from "@synd/App/Store/Selectors/GeneralSelectors";
import xIconsObject from "@synd/XDL/Icons/xngCommonIcons";
import React from "react";
import { connect } from "react-redux";

export interface HeaderMyListsStyles {
    headerClickable?: HeaderClickableStyles;
}

export const headerMyListsStyles: HeaderMyListsStyles = {};

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: xIsAuthenticated(state),
});

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const styles = headerMyListsStyles;

export const HeaderClickableWidget = ({ isAuthenticated, fields }: Props) => {
    const link = useGetLink(fields.link);

    if (fields.isGard && !isAuthenticated) {
        return null;
    }
    return (
        <HeaderClickable
            aria-label={fields.title}
            extendedStyles={styles.headerClickable}
            showIcon
            href={link.url}
            icon={{
                src: xIconsObject[fields.icon],
            }}
            subTitle={fields.subtitle}
        >
            {fields.label}
        </HeaderClickable>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(HeaderClickableWidget),
    definition: {
        displayName: "Header Clickable",
        fieldDefinitions: [
            {
                displayName: "Label",
                name: "label",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                displayName: "SubTitle",
                name: "subtitle",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                displayName: "Destination",
                name: "link",
                editorTemplate: "LinkField",
                defaultValue: {
                    type: "Url",
                    value: "",
                },
                fieldType: "General",
            },
            {
                name: "isGard",
                displayName: "Show It On Authenticated View Only",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: "icon",
                displayName: "Icon",
                editorTemplate: "IconField" as any,
                defaultValue: "",
                fieldType: "General",
            },
        ],
        group: "Header",
    },
};

export default widgetModule;
